const PARTNERS = [
  {
    name: "Nidhi Prayas",
    subtitle: "DST, Govt. of India",
    logo: "https://customer-assets.emergentagent.com/job_1488b547-0470-4710-9082-0fb679cd81f3/artifacts/lezm0jcx_nidhi-prayas-2-logo.png"
  },
  {
    name: "FITT",
    subtitle: "IIT Delhi",
    logo: "https://customer-assets.emergentagent.com/job_1488b547-0470-4710-9082-0fb679cd81f3/artifacts/tz7g77e2_logo.webp"
  },
  {
    name: "iCreate",
    subtitle: "Ahmedabad",
    logo: "https://customer-assets.emergentagent.com/job_1488b547-0470-4710-9082-0fb679cd81f3/artifacts/630c0vkp_2023-10-30-iCreate-Full-size-logo.png"
  }
];

export const FundingPartners = () => (
  <section id="partners" data-testid="partners-section" className="relative py-16 md:py-24 bg-slate-50">
    <div className="max-w-5xl mx-auto px-6 md:px-12">
      <div className="text-center mb-12">
        <span className="text-cyan-600 text-sm font-mono tracking-widest">Backed By</span>
        <h2 className="font-display text-2xl md:text-4xl font-bold text-slate-800 mt-3 mb-4">
          Our Funding <span className="gradient-text">Partners</span>
        </h2>
        <p className="text-slate-600">
          Supported by India's leading innovation ecosystems
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {PARTNERS.map((partner) => (
          <div
            key={partner.name}
            data-testid={`partner-${partner.name.toLowerCase().replace(/\s/g, '-')}`}
            className="group relative bg-white rounded-2xl p-8 border border-slate-200 hover:border-slate-300 hover:shadow-lg transition-all duration-300 text-center"
          >
            <div className="h-24 flex items-center justify-center mb-4">
              <img
                src={partner.logo}
                alt={partner.name}
                className="max-h-20 max-w-full object-contain group-hover:scale-105 transition-transform"
              />
            </div>
            <h3 className="font-display text-xl font-bold text-slate-800 mb-1">
              {partner.name}
            </h3>
            <p className="text-slate-500 text-sm">
              {partner.subtitle}
            </p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
